var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcExitRoundedPurple(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.51562 4.0147C4.62997 2.9004 5.9529 2.01649 7.40887 1.41344C8.86484 0.810387 10.4253 0.5 12.0013 0.5C13.5772 0.5 15.1377 0.810388 16.5937 1.41344C18.0496 2.01649 19.3725 2.9004 20.4869 4.0147C21.6012 5.129 22.4852 6.45186 23.0883 7.90776C23.6914 9.36366 24.0018 10.9241 24.0018 12.4999C24.0018 14.0758 23.6914 15.6362 23.0883 17.0921C22.4852 18.548 21.6012 19.8709 20.4869 20.9852L3.51562 4.0147Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.21297 19.2881C8.96216 23.0371 15.0408 23.0371 18.79 19.2881C22.5392 15.5391 22.5392 9.46076 18.79 5.71175C15.0408 1.96273 8.96216 1.96273 5.21297 5.71175C1.46378 9.46076 1.46378 15.5391 5.21297 19.2881ZM3.51584 20.9852C8.20233 25.6714 15.8006 25.6714 20.4871 20.9852C25.1736 16.2989 25.1736 8.70096 20.4871 4.0147C15.8006 -0.671566 8.20233 -0.671566 3.51584 4.0147C-1.17065 8.70096 -1.17065 16.2989 3.51584 20.9852Z",
    fill: "#3D0E6B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6786 8.82313C16.1473 9.29176 16.1473 10.0516 15.6786 10.5202L10.0216 16.177C9.5529 16.6456 8.79307 16.6456 8.32442 16.177C7.85577 15.7084 7.85577 14.9486 8.32442 14.48L13.9815 8.82313C14.4502 8.35451 15.21 8.35451 15.6786 8.82313Z",
    fill: "#3D0E6B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6788 16.1766C15.2101 16.6453 14.4503 16.6453 13.9817 16.1766L8.32456 10.5198C7.85591 10.0512 7.85591 9.2914 8.32456 8.82278C8.79321 8.35415 9.55304 8.35415 10.0217 8.82278L15.6788 14.4796C16.1474 14.9482 16.1474 15.708 15.6788 16.1766Z",
    fill: "#3D0E6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcExitRoundedPurple);
export default __webpack_public_path__ + "static/media/ic-exit-rounded-purple.c69d3d23b4d552a9972577a8a56508a5.svg";
export { ForwardRef as ReactComponent };